export default function (instance) {
    return {
        getCategories(params){
            return instance.get('shop/category/child', params)
        },
        getSales(params = null){
            return instance.get('shop/sale', params)
        },
        getCatalogChild(params = null){
            return instance.get('shop/catalog/child', params)
        },
        getCatalogItems(params){
            return instance.get('shop/catalog/items', params)
        },
        getCatalogTrainer(params){
            return instance.get('shop/catalog/trainer', params)
        },
        getCatalogContract(id){
            return instance.get('catalog/contract/'+id)
        },
        getCatalogService(id){
            return instance.get('catalog/service/'+id)
        },
    }
}